import { XYCoord, useDragLayer } from 'react-dnd';

import { CustomDragContainer } from './customer-drag-layer.style';
import { DroppableComponentData } from './droppable.constants';

export const CustomDragLayer = () => {
  const { isDragging, item, clientOffset, currentOffset } = useDragLayer<{
    item: DroppableComponentData;
    isDragging: Boolean;
    currentOffset: XYCoord | null;
    clientOffset: XYCoord | null;
  }>(monitor => ({
    item: monitor.getItem(),
    clientOffset: monitor.getClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging || !item.el) {
    return null;
  }

  const { x: currentX, y: currentY } = currentOffset || { x: 0, y: 0 };
  const { x: clientX, y: clientY } = clientOffset || { x: 0, y: 0 };

  return (
    <CustomDragContainer>
      <div
        style={{
          width: item.el.offsetWidth,
          height: item.el.offsetHeight,
          marginLeft:
            item.isColumnComponent && !item.menuItem
              ? `-${(item.el.offsetWidth / 2) * 0.5}px`
              : '0',
          position: 'fixed',
          pointerEvents: 'none',
          opacity: 0.5,
          zIndex: 100,
          left: currentX,
          top: currentY,
          transform: `scale(0.5) translate(${clientX - currentX}px, ${
            clientY - currentY
          }px)`,
          transformOrigin: 'left top',
        }}
        dangerouslySetInnerHTML={{ __html: item.el.innerHTML }}
      />
    </CustomDragContainer>
  );
};
